import { createSlice, createSelector } from '@reduxjs/toolkit'
import { userLogin } from './authActions'
import type { RootState } from '../../store'
import {parseJwt} from "../../helpers/helperFunctions";

const accessToken = localStorage.getItem('accessToken')
  ? localStorage.getItem('accessToken')
  : null

const initialState = {
  loading: false,
  userInfo: null,
  accessToken,
  error: null,
  success: false,
  userId: null
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout: (state) => {
      localStorage.removeItem('accessToken')
      state.loading = false
      state.userInfo = null
      state.accessToken = null
      state.error = null
    },
    setUserId: (state) => {
      const accToken = localStorage.getItem('accessToken')
        ? localStorage.getItem('accessToken')
        : null
      let parsedJWT = parseJwt(accToken)
      state.userId = parsedJWT.id
    }
  },
  extraReducers: builder => {
    builder.addCase(userLogin.pending, (state)=> {
        state.loading = true
        state.error = null
    })
    builder.addCase(userLogin.fulfilled, (state: any, { payload }: { payload: any })=> {
        state.loading = false
        state.userInfo = payload
        state.accessToken = payload.accessToken
    })
    builder.addCase(userLogin.rejected, (state: any, { payload }: { payload: any })=> {
        state.loading = false
        state.error = payload
    })
  }
})

export const { logout, setUserId } = authSlice.actions

export default authSlice.reducer

const selectSelf = (state: RootState) => state

export const getUser1 = createSelector(
  selectSelf,
  (state: RootState) => state.auth.userId
)